import type { IconProps } from '../create-icon'

export function LoLMid({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill={color}
      fillRule="evenodd"
      className={className}
      style={style}
      {...rest}
    >
      <path opacity="0.5" d="M30,12.968l-4.008,4L26,26H17l-4,4H30ZM16.979,8L21,4H4V20.977L8,17,8,8h8.981Z" />
      <polygon points="25 4 4 25 4 30 9 30 30 9 30 4 25 4" />
    </svg>
  )
}
